import { useState } from 'react';
import { useEventListener } from '@nike/privacy-shared-react';
import type { ContextFrameNamesModal } from '@nike/privacy-types';

import { getInlineCustomEventNames } from '../helpers/customEventNames';

/**
 * @name useInitializeInlineError
 * @description Hook which uses to get inline error state
 * @param {ContextFrameNamesModal | undefined} contextFrameName - a namespace to retrieve interactions from
 * @returns {boolean}
 */
export const useInitializeInlineError = (
  contextFrameName: ContextFrameNamesModal | undefined,
): boolean => {
  const [isErrorDisplayed, setIsErrorDisplayed] = useState(false);

  const inlineCookieCustomEventNames = getInlineCustomEventNames(contextFrameName);

  useEventListener(inlineCookieCustomEventNames.INITIALIZE_ERROR, () => {
    setIsErrorDisplayed(true);
  });

  return isErrorDisplayed;
};
